var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "licenses__wrapper" },
    _vm._l(_vm.licenses, function (childItem, index) {
      return _c(
        "Accordion",
        {
          key: index,
          attrs: {
            id: childItem.tid,
            full: true,
            "dir-button": true,
            "dir-button-left": true,
            title: childItem.name,
            pid: _vm.jurisdiction,
            "jurisdiction-parent": _vm.jurisdictionParent,
            size: "accordion-heading",
            level: "license",
          },
          on: { loadLicenses: _vm.loadLicenses },
        },
        [
          _c(
            "client-only",
            [
              childItem.requirements && childItem.requirements.length > 0
                ? _c("RequirementsList", {
                    attrs: {
                      jurisdiction: _vm.jurisdiction,
                      "category-parent": childItem.tid,
                      requirements: childItem.requirements,
                    },
                  })
                : _c("div", { staticClass: "loading-data" }, [
                    _vm._v("Loading Requirements..."),
                  ]),
            ],
            1
          ),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }